import { AutocompleteType } from './autocomplete';

export interface ITextAreaField {
  autocomplete: AutocompleteType;
}

export class TextAreaField implements ITextAreaField {
  autocomplete: AutocompleteType = 'on';

  constructor(configOverride?: Partial<ITextAreaField>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
